import { Component, Input, OnInit } from '@angular/core';
import { AlertController, LoadingController, ModalController } from '@ionic/angular';
import { ApiserviceService } from 'src/app/httpservice/apiservice.service';
import { errDelMsg, sccDelMsg } from '../delete-customer-modal/delete-customer.const';
 
@Component({
  selector: 'app-delete-customer-modal',
  templateUrl: './delete-customer-modal.component.html',
  styleUrls: ['./delete-customer-modal.component.scss'],
})
export class DeleteCustomerModalComponent implements OnInit {

  @Input() buyerName;
  @Input() taxId;
  @Input() buyerId;

  constructor(public modalCtrl: ModalController, private apiService: ApiserviceService,
    private loadingController: LoadingController, private alertController: AlertController) { }

  ngOnInit() {}
  validateResponse(respone) {
    if(typeof respone !== 'object') {
      return false;
    }
    if(!respone.hasOwnProperty('statusMessage')) {
      return false;
    }
    if(respone.statusCode !== 200) {
      return  false;
    }
    return true;
  }

  cancelModal() {
    this.modalCtrl.dismiss({
          confirm: false
    });
  }

  async confirmModal() {
    const reqBody = {
      deleteCustomerData :{
        buyer_id: this.buyerId
   }
    }
    const response = await this.apiService._post(this.apiService.apiUrl + this.apiService.editCustomer, reqBody);
    const valid = this.validateResponse(response);

    try {
      if(!valid) {
        this.modalAlert(errDelMsg.errDel);
      } else {
        this.modalAlert(sccDelMsg.sccDel);
        this.modalCtrl.dismiss({
          confirm: true
        })
      }
    } catch(e) {}
  }
  async modalAlert(altMsg) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: altMsg
    });
    await alert.present();
    setTimeout(() => {
      alert.dismiss(true);
    }, 2000);
  }
}
